import { bandeauBeneficesMock, formulaireRdvMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [bandeauBeneficesMock, formulaireRdvMock];

export const tunnelStep3Mock: SlugPage = {
  ...pageBase({
    title: 'Tunnel RDV - Etape 3',
    type: 'tunnel',
    language: 'fr-FR',
    headerId: 'tunnel-fr',
    footerId: '',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
